import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { destroy as destroyOrder, put } from '../modules/order'
import { postMultiple } from '../modules/orders'
import {
  edit as editStaging,
  commit as commitStaging,
  destroy as destroyStaging,
  wipe as wipeStaging
} from '../modules/staging'

import moment from 'helpers/moment'

import component from 'components/Orders/Edit'

const formName = 'edit-order'
const fields = ['id', 'date', 'customer_id', 'product_id', 'uom_id', 'option_id', 'notes', 'qty']

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroyOrder, // NOTE: this cannot be named destroy as reduxForm uses that..
  editStaging,
  destroyStaging,
  wipeStaging,
  destroyOrder
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

// This allows for me to have state, dispatch, and props, so I can put customer onto the staging order.
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps

  const newProps = {
    commitStaging: (data) => { // See Notes in OrdersContainer.js
      if (!data) return

      dispatch(postMultiple(data)).then(result => {
        if (!result.error) {
          dispatch(commitStaging())
        }
      })

      // reset the form now
      dispatch(reset(formName))
      dispatch(destroy(formName))
      dispatch(initialize(formName, stateProps.initialValues, fields))
    }
  }

  return Object.assign({}, ownProps, stateProps, dispatchProps, newProps) // further right = override
}

const mapStateToProps = (state) => {
  let obj = {
    staging: state.staging,
    orders: state.orders,
    order: state.order,
    pricelist: state.pricelist,
    customers: state.customers,
    options: state.options,
    uoms: state.uoms,
    isAdmin: state.auth && state.auth.isAdmin,
    user: state.auth && state.auth.user
  }

  obj.order.date = moment(state.order.date).format('YYYY-MM-DD')
  obj.date = obj.order.date

  obj.initialValues = obj.order

  if (state.auth && state.auth.isAdmin) {
    obj.routes = state.routes && typeof state.routes.sort === 'function' &&
      state.routes.sort((a, b) => {
        // put disabled proucts at the bottom
        if (a.day_of_week === '*') return -10
        if (b.day_of_week === '*') return 10
        return a.day_of_week - b.day_of_week
      })
  }

  return obj
}

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.date) errors.date = 'Please select a date for the order.'
    if (!state.customer_id) errors.customer_id = 'Please select a customer.'
    if (!state.product_id) errors.product_id = 'Please select a product.'
    if (!state.qty) errors.qty = 'Please enter a quantity.'
    else if (!parseFloat(state.qty) || parseFloat(state.qty) <= 0) errors.qty = 'Please enter a valid quantity.'
    if (!state.uom_id) errors.uom_id = 'Please select a unit of measure.'
    if (state.notes && state.notes.length > 50) errors.notes = 'Order Notes should be a maximum 50 characters.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Orders/containers/EditOrderContainer.js